import { useEffect } from "react";
import { Helmet } from "react-helmet";


import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import '../pages/Energy.css'
import EnergyBan from "../components/EnergyBan";
import RADLOGO from "../images/RADLOGO.jpeg";
import ENERGYAUDITIMAGE from "../images/ENERGYAUDITIMAGE.png";


import {
  FaBolt,
  FaChartLine,
  FaUniversity,
  FaCertificate,
  FaLeaf
} from "react-icons/fa";



import {

  FaLightbulb,
  FaClipboardCheck,
  FaIndustry,
  FaBuilding,
  FaHospital,
  FaSchool,
  FaCity
} from "react-icons/fa";


export default function Energy() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (
    <>
      <Helmet>
        <title>Professional Energy Audit Services in Madurai | NAAC Accreditation Support</title>
        <meta name="description" content="RAD EnviroNex provides comprehensive Energy Audit services in Madurai. We help industries and institutions reduce energy costs and meet NAAC accreditation standards." />
        <meta name="keywords" content="Energy Audit Madurai, Energy Audit Certification, NAAC Energy Audit, Industrial Energy Audit Tamil Nadu, Reduce EB Bill Madurai, Energy conservation audit" />
        <link rel="canonical" href="https://radenvironex.com/Energy" />
      </Helmet>
      <Navbar />



      <EnergyBan />




      {/* ENERGY AUDIT SECTION */}
      <section id="energy-audit-section">
        <div className="energy-audit-wrapper" data-aos="slide-up">

          <h2>Energy Audit</h2>

          <p className="energy-audit-intro">
            At <strong>RAD EnviroNex,</strong> we conduct comprehensive Energy Audits to help organizations analyze and optimize their energy consumption. Our audit evaluates energy usage across buildings, equipment, and operational processes to identify inefficiencies and opportunities for improvement<br />
            Through detailed assessment and practical recommendations, we help institutions and industries reduce energy costs, improve operational efficiency, and adopt sustainable energy practices that contribute to long-term environmental and economic benefits.
          </p>

          <div className="energy-audit-grid">

            <div data-aos="slide-up">
              <FaChartLine />
              <p>
                Detailed assessment of electrical and mechanical energy usage to
                identify inefficiencies, losses, and improvement opportunities.
              </p>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaCertificate />
              <p>
                RAD EnviroNex provides <strong>Professional Energy Audit Certificates</strong>
                to institutions, industries, hospitals, and commercial establishments.
              </p>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaUniversity />
              <p>
                Our energy audit certification supports institutions seeking
                <strong> NAAC accreditation</strong>, aligned with sustainable energy
                management practices.
              </p>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaLeaf />
              <p>
                Supports compliance under <strong>NAAC Criterion 7.1.6</strong>:
                “Quality audits on environment and energy are regularly undertaken
                by the institution.”
              </p>
            </div>

          </div>

        </div>
      </section>





      <Footer />




    </>
  )
}
